import { NavLink, useLocation } from "react-router-dom";
import { FaHome, FaThLarge, FaGift, FaUserCircle } from "react-icons/fa";

export default function MobileAppNavigation() {
  const { pathname } = useLocation();
  return <nav className="mobile-app-navigation" aria-label="Mobile navigation">
    <NavLink to="/" end><FaHome /><span>Home</span></NavLink>
    <NavLink to="/rng"><FaThLarge /><span>Games</span></NavLink>
    <NavLink to="/promotions"><FaGift /><span>Offers</span></NavLink>
    <NavLink to="/member" className={pathname.startsWith('/member') ? 'active' : ''}><FaUserCircle /><span>Account</span></NavLink>
  </nav>;
}
